import React from 'react';
import {
  CostPerCharFromFlagFeature,
  ConcurrentCCRFeature,
} from './SharedApiFeatures';
import CheckOrCross from '../Shared/CheckOrCross';

const FEATURE_NAME = 'tts-streaming';

const ttsStreamingFeatures = ({ packages, ttsConfig }) => ({
  enabled: {
    key: 'tts-streaming-enabled',
    label: 'ttsStreaming',
    values: packages.map((pkg) => (
      <CheckOrCross
        key={pkg.code}
        isCheck={!!pkg?.features?.includes(FEATURE_NAME)}
      />
    )),
  },
  costPerCharacter: {
    key: 'tts-streaming-cost-per-char',
    label: 'costPerCharacter',
    values: packages.map((pkg) => (
      <CostPerCharFromFlagFeature
        key={pkg.code}
        pkg={pkg}
        creditPerChar={ttsConfig?.creditPerChar}
        featureName={FEATURE_NAME}
      />
    )),
    tooltipContent: 'tooltipBasicVoice',
  },
  concurrentCCR: {
    key: 'tts-streaming-ccr',
    label: 'concurrentAPIRequests',
    values: packages.map((pkg) => (
      <ConcurrentCCRFeature
        key={pkg.code}
        pkg={pkg}
        ccr={pkg?.apiCcr?.tts?.streaming}
      />
    )),
  },
});

export default ttsStreamingFeatures;
